import { BackendLink } from "../BackEndLink";

export default async function GetData(Url) {
    const requestOptions = {
        method: "GET",
    };

    return fetch(`${BackendLink}${Url}`, requestOptions)
        .then((response) => {
            if (response.status !== 200) {
                return new Error("Access token is empty");
            }
            return response.json();
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            new Error(error);
        });
}
